/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Embed_Captions_Pricing_Subtotal_LabelInputs */



/**
* | output |
* | --- |
* | "Subtotal:" |
*
* @param {Embed_Captions_Pricing_Subtotal_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const embed_captions_pricing_subtotal_label = /** @type {((inputs?: Embed_Captions_Pricing_Subtotal_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Embed_Captions_Pricing_Subtotal_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Sous-total :")
	if (locale === "de") return /** @type {LocalizedString} */ ("Zwischensumme:")
	if (locale === "it") return /** @type {LocalizedString} */ ("Subtotale:")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Промежуточный итог:")
	if (locale === "es") return /** @type {LocalizedString} */ ("Subtotal:")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("小计：")
	if (locale === "ja") return /** @type {LocalizedString} */ ("小計:")
	if (locale === "hi") return /** @type {LocalizedString} */ ("उप-योग:")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Subtotal:")
	return /** @type {LocalizedString} */ ("Subtotal:")
});